import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export const ImageLogo = ({ logo }) => {
  const data = useStaticQuery(graphql`
    query {
      hayes: file(relativePath: { eq: "hayes.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      patton: file(relativePath: { eq: "Patton.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      stafford: file(relativePath: { eq: "stafford.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      trustPower: file(relativePath: { eq: "trust-power.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      heinz: file(relativePath: { eq: "heinz.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      pacific: file(relativePath: { eq: "pacific steel.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      eastbridge: file(relativePath: { eq: "eastbridge.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ballance: file(relativePath: { eq: "ballance.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      weCan: file(relativePath: { eq: "We-Can-Logo-header5.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <>
      {logo === "patton" ? (
        <Img
          fluid={data.patton.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "stafford" ? (
        <Img
          fluid={data.stafford.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "hayes" ? (
        <Img
          fluid={data.hayes.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "trustPower" ? (
        <Img
          fluid={data.trustPower.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "pacific" ? (
        <Img
          fluid={data.pacific.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "heinz" ? (
        <Img
          fluid={data.heinz.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "eastbridge" ? (
        <Img
          fluid={data.eastbridge.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "ballance" ? (
        <Img
          fluid={data.ballance.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : logo === "weCan" ? (
        <Img
          fluid={data.weCan.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
        />
      ) : (
        <div></div>
      )}
    </>
  )
}
